(ns graph-ui.web.unsaved
  "TEXT A PERSON TYPED THAT THE SERVER HAS NOT ACCEPTED, kept where a remount
   cannot reach it.

  ;; @feature F-platform-v0-011-01-highlights
  ;; @plan    PLAN-ikc-v3-018-01-protect-work-edits

  George, 2026-08-23, after losing a note on this deployment: *a write that
  cannot complete must STALL, visibly. It must never VANISH.*

  widgets.cljs already names this failure in `draft-holding-kinds`: \"A remount
  seeds the buffer from the bound value again, which is the LAST SAVED text — so
  the unsaved part is gone with no message.\" That comment protects against ONE
  cause, a tab-set unmounting the tab you were typing in. It cannot protect
  against the other: the widget tree being REPLACED, which remounts every row at
  once.

  AND A RECONNECT DOES EXACTLY THAT. George, 2026-09-08: \"Web page does not
  reconnect with the server after bus restart.\" Making it reconnect means
  re-attaching, and re-attaching hands down a new widget tree — so the repair
  for the connection would have destroyed the text the stall had just saved.
  Measured 2026-09-08 before this namespace existed: the words survived Enter
  with the bus down, and were gone the moment it came back.

  A ROW'S BUFFER IS A REAGENT ATOM INSIDE ITS COMPONENT, so it dies with the
  component. This is a `defonce` in a namespace, so it does not. That is the
  whole mechanism.

  WHAT IT IS NOT. It is not persistence and it must not become it: nothing here
  reaches localStorage or the bus. It survives a re-render, not a reload — a
  reload is a person deciding to throw the page away, and silently restoring
  text into a page they chose to reset would be its own surprise. It is also
  not a queue of edits to replay: the person still presses Enter. It only keeps
  their words on the screen so that they can."
  (:require [reagent.core :as r]))

(defonce ^:private buffers
  ;; {block-id-string text}. A reagent atom rather than a plain one so a future
  ;; reader — an indicator saying \"3 blocks unsaved\" — can deref it and
  ;; re-render. Nothing derefs it reactively today.
  (r/atom {}))

(defn remember!
  "Keep `text` as the unsaved buffer of `block-id`. Called on every keystroke,
   which is cheap: one assoc into a map of the rows being edited right now,
   and in practice that map holds one entry."
  [block-id text]
  (when block-id (swap! buffers assoc (str block-id) text)))

(defn forget!
  "Drop `block-id`'s buffer. Called when the SERVER has accepted the text, and
   on Escape — the two ways a person is finished with it. Never called on a
   refusal, which is the case this namespace exists for."
  [block-id]
  (when block-id (swap! buffers dissoc (str block-id))))

(defn text
  "The unsaved text for `block-id`, or nil.

   nil AND EMPTY STRING ARE DIFFERENT HERE. A row whose text a person deleted
   holds \"\", and that is an edit worth keeping — seeding the row from its old
   content instead would put the deleted words back on the screen as if the
   deletion had not happened."
  [block-id]
  (get @buffers (str block-id)))

(defn any?*
  "Is anything unsaved right now? For a caller that must not discard state —
   nothing asks yet, and the question is the reason this is a map and not a
   single value."
  []
  (boolean (seq @buffers)))
